module.exports = __webpack_public_path__ + "img/1b9f1b0.svg";